// Kline volume is an absolute base-asset total for one interval, never a tick delta.
export function binanceInterval(tf) {
    return String(tf).replace(/H$/, 'h').replace(/D$/, 'd').replace(/W$/, 'w');
}
export function binanceSubscriptions(symbol, timeframes) {
    const pair = String(symbol).split(':').pop().replace('/', '').replace(/\.P$/i, '').toLowerCase();
    const supported = new Set(['1m','3m','5m','15m','30m','1h','2h','4h','6h','8h','12h','1d','3d','1w','1M']);
    return [...new Set(timeframes.map(binanceInterval))].filter(tf => supported.has(tf)).map(tf => `${pair}@kline_${tf}`);
}
export function klineCandle(k) {
    const row = [k.t, k.o, k.h, k.l, k.c, k.v].map(Number);
    return row.every(Number.isFinite) && row[5] >= 0 && row[2] >= Math.max(row[1], row[4]) && row[3] <= Math.min(row[1], row[4]) ? row : null;
}
export function mergeRecoveredCandles(current, recovered, live = []) {
    const rows = new Map(current.map(row => [row[0], row]));
    for (const row of recovered) {
        if (!Array.isArray(row) || row.length < 6 || !row.slice(0,6).every(Number.isFinite) || row[5] < 0) throw new Error('Provider returned invalid candle data.');
        rows.set(row[0], row.slice(0,6));
    }
    // Absolute stream updates received during the request supersede the REST snapshot.
    for (const row of live) {
        const snapshot=rows.get(row[0]);
        if(!snapshot || row[5]>=snapshot[5])rows.set(row[0],row);
    }
    return [...rows.values()].sort((a,b) => a[0]-b[0]);
}
// Page backwards until the last known candle is reached; never silently accept a
// truncated recovery after a long outage or a provider's pagination limit.
export async function recoverCandles(fetchPage, anchor, endTime, maxPages = 20) {
    let cursor = endTime + 1, result = [], previous = Infinity;
    for (let page = 0; page < maxPages; page++) {
        const rows = await fetchPage(cursor);
        if (!Array.isArray(rows) || !rows.length) throw new Error('Provider returned no recovery candles.');
        const valid = mergeRecoveredCandles([], rows).filter(row => row[0] <= endTime);
        if (!valid.length || valid[0][0] >= previous) throw new Error('Provider cannot page far enough to recover this gap.');
        result = mergeRecoveredCandles(valid, result);
        if (valid[0][0] <= anchor) return result.filter(row => row[0] >= anchor);
        previous = valid[0][0]; cursor = previous;
    }
    throw new Error('Recovery exceeded 20 pages. Retry or reload chart history.');
}
